import I18n from 'I18n';
//@ts-expect-error untyped file
import { getSendFrom } from 'conversations-internal-schema/widget-data/operators/widgetDataGetters';
//@ts-expect-error untyped file
import { buildSendFromResponders } from 'conversations-internal-schema/widget-data/operators/buildSendFromResponders';
const useWidgetData = (widgetData, previewAwayMessage) => {
  const {
    message: {
      chatHeadingConfig,
      initialMessage,
      knowledgeBaseEnabled,
      knowledgeBaseRecommendationType,
      searchableKnowledgeBaseIds
    },
    coloring,
    knowledgeBaseUrl,
    isKnowledgeBaseV3,
    sendFrom,
    enableSdkCloseButton = false
  } = widgetData;
  const firstMessage = previewAwayMessage || initialMessage || I18n.text('conversations-visitor-experience-components.default.repText');
  const knowledgeBaseId = searchableKnowledgeBaseIds === null || searchableKnowledgeBaseIds === void 0 ? void 0 : searchableKnowledgeBaseIds.first();
  const sendFromResponders = getSendFrom(widgetData);
  const responder = buildSendFromResponders(widgetData).first();
  return {
    chatHeadingConfig,
    initialMessage,
    knowledgeBaseEnabled,
    knowledgeBaseRecommendationType,
    knowledgeBaseId,
    knowledgeBaseUrl,
    isKnowledgeBaseV3,
    coloring,
    sendFrom,
    firstMessage,
    sendFromResponders,
    responder,
    enableSdkCloseButton
  };
};
export default useWidgetData;